import { LevelDisplay } from './LevelDisplay';
import { StatsBar } from './StatsBar';

export const Header = ({
  sendItScore,
  animatedStreak,
  animatedScore,
  longestStreak,
  pulseScore,
}) => {
  return (
    <div className="text-center mb-4 sm:mb-5 md:mb-6 pt-4 sm:pt-5 px-3 sm:px-4">
      <div className="mb-3 sm:mb-4">
        <div className="relative inline-block">
          <h1 className="text-4xl sm:text-6xl md:text-7xl font-black tracking-tighter mb-2 sm:mb-3 leading-none" style={{
            background: 'linear-gradient(45deg, #00ff00, #ffff00)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            textShadow: '0 0 40px rgba(0,255,0,0.5)'
          }}>
            SENDITMAXX
          </h1>
          <div className="absolute -inset-2 bg-gradient-to-r from-lime-500/20 to-yellow-500/20 blur-xl -z-10"></div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-lime-500 to-yellow-400 px-3 xs:px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 inline-block mb-4 sm:mb-5 md:mb-6 skew-x-[-5deg] max-w-full">
        <p className="text-black text-sm xs:text-base sm:text-lg md:text-xl font-black uppercase tracking-wide sm:tracking-wider skew-x-[5deg]">
          NO EXCUSES • JUST SEND IT
        </p>
      </div>

      {/* ALWAYS SHOW LEVEL - Enhanced Display */}
      <LevelDisplay sendItScore={sendItScore} />

      <StatsBar
        animatedStreak={animatedStreak}
        animatedScore={animatedScore}
        longestStreak={longestStreak}
        pulseScore={pulseScore}
      />
    </div>
  );
};
